import { Anchor } from "client/Components";
import { getCurrentCulture, localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export const UserLicenseDescription = (): ReactElement => {
	const pricingUrl: string = currentCulture === "nl"
		? PRICING_URL_BY_CULTURE[currentCulture]
		: PRICING_URL_BY_CULTURE.en;

	return (
		<Anchor
			href={pricingUrl}
			trackingId="view-features"
			target="_blank"
		>
			{localize("_ViewFeatures")}
		</Anchor>
	);
};
UserLicenseDescription.displayName = "UserLicenseDescription";

const currentCulture: string = getCurrentCulture();

const PRICING_URL_BY_CULTURE = {
	en: "https://workspace365.net/en/pricing",
	nl: "https://workspace365.net/nl/prijzen"
} as const;